import { Main } from "./Main";
import { _APP_VERSION_BUILD, _APP_VERSION_NAME } from "./core/config/AppConfig";
import { globalSearchService } from "./core/services/global-search-service";
import "./ui/controlWC/.main";
import '/style/base.scss';

globalSearchService.init();
Main._Iniciar();

const v = `${_APP_VERSION_NAME}/${_APP_VERSION_BUILD}`
console.warn("version: %c" + v, "background-color: #d30c7b; color: #FFF;");